import SuggestedActionItem from './SuggestedActionItem.component';

export default SuggestedActionItem;
